import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { updateBanner, deleteBanner } from "../store/actions/banner";
import { useDebounce } from "../utils/hooks";
import BannerPreview from "./BannerPreview";

const BannerCard = ({ banner }) => {
  const dispatch = useDispatch();
  const [priority, setPriority] = useState(banner.priority);
  const [showPreview, setShowPreview] = useState(false);

  const handleUpdateBanner = useDebounce((bannerId, updates) => {
    dispatch(updateBanner(bannerId, updates));
  }, 500);

  const handlePriorityChange = (e) => {
    const newPriority = e.target.value;
    setPriority(newPriority);
    handleUpdateBanner(banner.id, {
      is_live: banner.is_live,
      priority: newPriority,
    });
  };

  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete this banner?")) {
      dispatch(deleteBanner(banner.id));
    }
  };

  return (
    <>
      <div key={banner.id} className="banner-card">
        <img
          src={banner.url}
          alt="Banner"
          onClick={() => setShowPreview(true)}
          style={{ cursor: "pointer" }}
        />
        <div className="banner-controls">
          <div className="banner-info">
            <span>Priority: {banner.priority}</span>
            <span>
              Status:{" "}
              <span
                className={banner.is_live ? "status-live" : "status-hidden"}
              >
                {banner.is_live ? "Live" : "Hidden"}
              </span>
            </span>
          </div>
          <div className="banner-actions">
            <input
              type="number"
              value={priority}
              onChange={handlePriorityChange}
            />
            <button
              onClick={() =>
                handleUpdateBanner(banner.id, {
                  is_live: !banner.is_live,
                })
              }
            >
              {banner.is_live ? "Hide" : "Show"}
            </button>
            <button className="banner-delete-btn" onClick={handleDelete}>
              Delete
            </button>
          </div>
        </div>
      </div>
      {showPreview && (
        <BannerPreview
          imageUrl={banner.url}
          onClose={() => setShowPreview(false)}
        />
      )}
    </>
  );
};

export default BannerCard;
